import { Log } from 'ng2-logger';
import Types, { IAppState, GlobalState } from '../../models/action/core.d';

import * as Actions from '../constants/announcement';
import { IAnnouncementsSetAction, ISelectedAnnouncementSetAction, ISetAddAnnouncement, ILoginAnnouncementSetAction, ISetAnnouncementActionParams, ISetUnreadAnnouncementCount, ISetLoginAnnouncementError } from '../../models/action/announcement';

const _logger = Log.create('Announcement Reducer');

const announcementReducer = (state = GlobalState().announcement, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = { ...state };
    if (action.type === Actions.actions.LOGIN_ANNOUNCEMENT_SET) {
        const pageData = (action as ILoginAnnouncementSetAction);
        newState.announcementData = pageData.loginAnnouncementData;
    } else if (action.type === Actions.actions.SET_ANNOUNCEMENT_LIST) {
        const announcementPageAction = action as IAnnouncementsSetAction;
        if (announcementPageAction.isHomePageAnnouncement) {
            if (announcementPageAction.lastAnnouncementId) {
                if (announcementPageAction.announcements.length > 0) {
                    newState.homePageAnnouncements = announcementPageAction.announcements.concat(newState.homePageAnnouncements);
                }
            } else {
                newState.homePageAnnouncements = announcementPageAction.announcements;
            }
        } else {
            if (announcementPageAction.skip === 0) {
                newState.announcements = [];
            } else {
                newState.announcements = state.announcements;
            }
            newState.announcements = newState.announcements.concat(announcementPageAction.announcements);
            newState.announcementTake = announcementPageAction.take;
            newState.announcementSkip = announcementPageAction.skip;
            if (newState.announcements.length > 0 && !newState.announcements[0].showReadConfirmation)
                newState.announcements[0].isRead = true;
        }
        if (announcementPageAction.announcements && announcementPageAction.announcements[0]) {
            newState.unreadCount = announcementPageAction.announcements[0].unreadCount;
        }
    } else if (action.type === Actions.actions.ADD_ANNOUNCEMENT) {
        const announcementPageAction = action as ISetAddAnnouncement;
        newState.addAnnouncementStatus = announcementPageAction.addAnnouncementStatus;
    } else if (action.type === Actions.actions.SET_SELECTED_ANNOUNCEMENT) {
        const announcementPageAction = action as ISelectedAnnouncementSetAction;
        if (typeof announcementPageAction.announcementIndex === 'number') {
            if (state.homePageAnnouncements.length > 0 && state.homePageAnnouncements[announcementPageAction.announcementIndex]) {
                newState.homePageAnnouncements = state.homePageAnnouncements;
                if (!newState.homePageAnnouncements[announcementPageAction.announcementIndex].showReadConfirmation)
                    newState.homePageAnnouncements[announcementPageAction.announcementIndex].isRead = true;
            }
        }
        newState.selectedAnnouncement = announcementPageAction.selectedAnnouncement;
        if (announcementPageAction.selectedAnnouncement && state.unreadCount > 0 && !announcementPageAction.selectedAnnouncement.isRead) {
            newState.unreadCount = state.unreadCount - 1;
            if (announcementPageAction.announcementIndex) {
                if (state.announcements.length > 0) {
                    newState.announcements = state.announcements;

                    newState.announcements[announcementPageAction.announcementIndex].isRead = true;
                }
            }
        }
    } else if (action.type === Actions.actions.SET_ANNOUNCEMENT_DATA) {
        const announcementPageAction = action as ISetAnnouncementActionParams;
        newState.editAnnouncementData = announcementPageAction.announcementData;
    } else if (action.type === Actions.actions.SET_ANNOUNCEMENT_DATA_DEFAULT) {
        newState.editAnnouncementData = {
            targets: [],
            content: '',
            smsContent: '',
            fileUploadKey: '',
            isSms: false,
            isEmail: false,
            isNotification: false,
            isPin: false,
            isShowOnStartUp: false,
            announcementId: '',
            subject: '',
            alwaysOnTop: false,
            notificationContent: '',
        };
    } else if (action.type === Actions.actions.SET_SELECTED_ANNOUNCEMENT_DATA_DEFAULT) {
        newState.selectedAnnouncement = null;
    } else if (action.type === Actions.actions.SET_UNREAD_ANNOUNCEMENT_COUNT) {
        const unreadAnnouncement = action as ISetUnreadAnnouncementCount;
        newState.mainMenuAnnouncementUnread = unreadAnnouncement.unreadAnnouncementCount && unreadAnnouncement.unreadAnnouncementCount > 0 ? true : false;
        newState.unreadAnnounceCount = unreadAnnouncement.unreadAnnouncementCount;

    }else if(action.type === Actions.actions.SET_LOGIN_ANNOUNCEMENT_ERROR){
        const setloginAnnouncementError = action as ISetLoginAnnouncementError;
        newState.loginAnnouncementError = setloginAnnouncementError.isError;
    }
    else {
        return state;
    }

    // SET_ANNOUNCEMENT_DATA
    return Object.assign({}, state, newState);
};

export default announcementReducer;
